const initBlock = function( $block ) {
	const $counter = $block.find( '.js-counter' );

	if ( $counter.length < 1 ) {
		return;
	}

	$counter.each( function() {
		const $el = $( this );
		$el.text( $el.data( 'max' ) );
	} );
};

app.loadBlock( initBlock, 'about-us-metrics', '.section-about-us-metrics' );

if ( module.hot ) {
	module.hot.accept();
}
